import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
export default {
	/**
	 * 策略列表
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量
	**/
	strategyList( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/device/Strategy',
	    method: 'GET',
	    params
	  })
	},


	/**
	 * 定时策略分配
	 * @param {group} 路灯ID
	**/
	getLampAndGroupByStrategy( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/device/getLampAndGroupByStrategy',
	    method: 'GET',
	    params
	  })
	},


	// /**
	//  * 区域策略分配
	//  * @param {group} 路灯ID
	// **/
	// getSunStrategy( params={} ) {
	// 	params = commonJs.obj.removeNullKey(params)
	// 	return request({
	//     url: baseUrl + '/device/getSunStrategy',
	//     method: 'GET',
	//     params
	//   })
	// },

	/**
	 * 设备还原策略
	 * @param {id} 路灯ID
	 * @param {type} 1路灯策略  2 分组策略
	**/
	recoveryStrategy( data={} ) {
		return request({
	    url: baseUrl + '/device/recoveryStrategy',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 设备还原策略
	**/
	recoveryAll() {
		return request({
	    url: baseUrl + '/device/recoveryUserStrategy',
	    method: 'POST'
	  })
	},


	/**
	 * 根据经纬度查询日落日出时间
	 * @param {longitude, latitude} 经纬度
	**/
	getDateSunInfo( data={} ) {
		return request({
	    url: baseUrl + '/device/getDateSunInfo',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 策略编辑
	**/
	strategyEdit(id,data){
		return request({
			url: baseUrl + '/device/Strategy/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 策略添加
	**/
	strategyAdd(data){
		return request({
			url: baseUrl + '/device/Strategy',
			method:'POST',
			data
		})
	},

	/**
	 * 策略删除
	**/
	strategyDel(id){
		return request({
			url: baseUrl + '/device/Strategy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 策略分配-分配或者取消策略
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {stg_id} 策略ID
	**/
	allotFen(data){
		return request({
			url: baseUrl + '/device/StrategyFen',
			method:'POST',
			data
		})
	},

	/**
	 * Lora空开开关闸
	**/
	airOpenControl(id,data){
		return request({
			url: baseUrl + '/device/setStrategySte/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 策略详情
	 * @param {id} 策略ID
	**/
	getStrategyInfo(id) {
		return request({
	    url: baseUrl + '/device/getStrategyInfo/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 集中控制器策略列表
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量 
	**/
	foucusStrategyList( params={} ) {
		return request({
	    url: baseUrl + '/concentrator/Strategy',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 集中控制器策略编辑
	**/
	foucusStrategyEdit(id,data){
		return request({
			url: baseUrl + '/concentrator/Strategy/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 集中控制器策略添加
	**/
	foucusStrategyAdd(data){
		return request({
			url: baseUrl + '/concentrator/Strategy',
			method:'POST',
			data
		})
	},

	/**
	 * 集中控制器策略删除
	**/
	foucusStrategyDel(id){
		return request({
			url: baseUrl + '/concentrator/Strategy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 获取已分配策略的列表
	 * @param {id} 策略id
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量 
	**/
	foucusHaveStrategy( id, params={} ) {
		return request({
	    url: baseUrl + '/concentrator/StrategyList/'+id,
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 集中控制器策略分配-分配或者取消策略
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {stg_id} 策略ID
	**/
	foucusAllotFen(data){
		return request({
			url: baseUrl + '/concentrator/StrategyFen',
			method:'POST',
			data
		})
	}
}